import { useMemo } from 'react';

/**
 * @param {string} field
 * @param {string} query
 * @returns {import('@mui/x-data-grid').GridFilterModel}
 */
export default function useDataGridSearch(field, query) {
    return useMemo(() => {
        if (!field) return undefined;

        return {
            items: [{
                columnField: field,
                operatorValue: 'contains',
                value: query,
            }],
        };
    }, [field, query]);
}